import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select } from 'components';
import { TrashIcon, ViewIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, GoogleMapsIcon, EditIcon } from 'assets/icons';
import { Globals, checkPermission, Constants, Print, SocketEvents } from 'utils';
import { UserService } from 'services';
import CreateUser from './create-user';
import { on } from 'jetemit';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	registered_in_id: '',
	user_type_id: ''
}

declare var window: any;

class Users extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'RIF / Cédula',
			'Teléfono',
			'Correo',
			'Acciones'
		],
		item: null,
		visible_confirm: false, 
		visible_delete: false,
		visible_add: false,
		unsubscriber: () => {}
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Usuarios',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.checkCorporate();
		this.load();

		this.setState({
			unsubscriber: on(SocketEvents.UPDATE_USER,() => {
				this.checkCorporate();
			})
		});
	}

	componentWillUnmount() {
		this.state.unsubscriber();
	}

	checkCorporate = () => {
		if (this.props.user?.user_type_id != Constants.USER_TYPES.CORPORATE) {
			this.props.history.replace('/');
		}
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			owner_id: this.props.user?.id
		});
		this.setState({
			data: res.users.rows,
			last_page: res.users.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	location = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_location: true,
			item
		});
	}

	confirmDelete = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_confirm: true,
			item
		});
	}

	delete = async () => {
		const item: any = this.state.item;
		await UserService.delete({
			user_id: item.id
		});
		await this.setState({
			visible_delete: true,
			visible_confirm: false,
			item: null
		});
		this.load(true);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setActive = (index: number) => {
		let data: any = [...this.state.data];
		data[index].active = !data[index].active;
		this.setState({
			data
		});
	}

	setAllActive = () => {
		let data: any = [...this.state.data];
		if (data.filter((i: any) => i.active).length == data.length) {
			data.map((i: any) => {
				i.active = false;
				return i;
			});
		}
		else {
			data.map((i: any) => {
				if (!i.active) {
					i.active = true;
				}
				return i;
			});
		}
		this.setState({
			data
		});
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false
		});
	}

	onCloseDelete = () => {
		this.setState({
			visible_delete: false
		});
	}

	onClose = () => {
		this.setState({
			visible: false
		});
	}

	add = () => {
		this.setState({
			visible_add: true
		});
	}

	onCloseAdd = () => {
		this.setState({
			visible_add: false,
			item: null
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_add: true,
			item
		});
	}
	
	render() {
		const { visible_confirm, visible_delete, visible_add } = this.state;

		return (
			<div id="clients">
				<BackComponent />

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar al usuario?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.delete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<div className={ `container-modal-right ${ visible_add ? 'active' : '' }` }>
					{
						visible_add && (
							// @ts-ignore
							<CreateUser
								item={ this.state.item }
								title={ `${ this.state.item ? 'Editar' : 'Nuevo' } Usuario` }
								onClose={ () => this.onCloseAdd() }
							/>
						)
					}
				</div>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha eliminado con éxito</h3>
					</div>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre del usuario"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-3">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						<button className="btn btn-add" onClick={ () => this.add() }>
							<img src={ AddWhiteIcon } />
						</button>
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header } childrenHeader={
					<th>
						<CheckboxTable 
							active={ this.state.data.filter((i: any) => i.active).length == this.state.data.length } 
							onClick={ () => this.setAllActive() } />
					</th>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									<CheckboxTable 
										active={ i.active } 
										onClick={ () => this.setActive(index) } />
								</td>
								<td>{ i.full_name }</td>
								<td>{ [Constants.DOCUMENT_TYPES.V,Constants.DOCUMENT_TYPES.E].indexOf(i.document_type_id) != -1 ? i.full_document : i.full_tax_document }</td>
								<td>
									<a href={ `https://wa.me/` + i.phone } target="_blank" onClick={ (e: any) => Globals.openWhatsapp(e,`https://wa.me/` + i.phone) }>
										{ i.phone }
									</a>
								</td>
								<td>{ i.email }</td>
								<td>
									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
											<img src={ EditIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.confirmDelete(e,i) }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Users);